import {
    getAllOrders,
    addOrder,
    uploadOrderFile,
    deleteOrder,
    getAllCustomersNameForOrder,
    getAllDamageCause,
    getAllApi,
    getOrganizationUnit,
    getPrintedInstanceType,
    getPrintedInstanceKeepStatus,
    getKlischeThikness,
    getKlischeTypes,
    getCustomerMachineInfo,
    getCustomerMachineInfoDetails,
    getDesignerOfCustomer,
    getOrganizationDepartman,
    getMachineLpi,
    getLastOrderNumber,
    getOrderDetails,
    getOrderView,
    deleteOrderImage,
    deleteOrderDepartmanDescription,
    getOrderByOrderNumber,
    getSingleOrder,
    updateOrder,
    getAllOrderDeliverInfo,
    deleteOrderAnilux,
    deleteOrderAniluxes,
    updateOrderColors,
    getOrderAniloxes,
    deleteColorSelection,
    getRefreshedOrderColors,
    deleteOrderPrintedInstance,
    getAllDesignerGroup,
    getOrderDamageByOrderId,
    AssignReturnsToOrder,
    GetOrderReturnsByOrderId



} from '../Api/index';
import { useQuery, useMutation, useQueryClient } from 'react-query';


import {
    setKlischeDetailsR,
    setPrintedInstanceKeepStatusR,
    setPrintedInstanceTypeR,
    clearAllR,
    setCustomerNamesForOrdersR,
    setCustomerKlischeThiknessR,
    setCustomerKlischeTypesR,
    setCustomerMachineInfoR,
    setCustomerMachineDetailsR,
    setCustomerDesignerR,
    setOrganizationUnitR,
    customerSendInfoList,
    setOrderViewDataR,
    setOrderSelectedR,
    setPreviousOrderR,
    setCustomerSendInfoListR,
    setAsyncOprationsMessagesR,
    setAddOrderSuccessDataR

} from '../OrderSlice/OrderSlice';
import { getOrderTotalR } from '../../../General/Store/GeneralSlice'
import { useDispatch } from 'react-redux'
import { getMessages } from '../../../CustomHoock/GetErrors/GetErrors';
import { setErrorsR } from '../../Qualitycontrol/SaleSlice/SaleSlice'





const useGetAllOrders = (orderBody, orderStatusNum) => {

    let orderBody2;
    if (orderStatusNum) {
        orderBody2 = { ...orderBody, orderStatus: orderStatusNum.orderStatus }
    }

    const dispatch = useDispatch();
    return useQuery(['getAllOrders', orderBody2], getAllOrders, {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        enabled: !!orderBody2,
        cacheTime: Infinity,
        onSuccess: () => {
        },
        onError: () => {
        },
        select: (data) => {
            dispatch(getOrderTotalR(data?.data.totalRecord))
            let rawData = data?.data.data;
            return rawData
        }
    })
}


const useNewGetAllOrders = (orderBody) => {



    return useQuery(
        [
            "getAllOrders",
            orderBody?.orderStatus,
            orderBody?.page,
            orderBody?.pageSize,
            orderBody?.searchTerm,
            orderBody?.orderStatusNumber,
        ],
        () => getAllOrders(orderBody),
        {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            enabled: !!orderBody,
            cacheTime: Infinity,

            onSuccess: () => { },
            onError: () => { },

            select: (data) => {
                return data?.data;
            },
        }
    );
};




// customerAgreementTerms



const useGetAllCustomersName = () => {
    const dispatch = useDispatch();
    return useMutation(getAllCustomersNameForOrder, {

        onSuccess: (data) => {
            let customerNamesRaw = data?.data.data;
            // console.log(customerNamesRaw)
            let customerSendInfoList = customerNamesRaw?.map(({ customerSendInfo, id, elasticNumbers, receivesFileTypeId, priorityType, purchaseInvoiceType, customerAgreementTerms }) => {
                return { id, customerSendInfo, elasticNumbers, receivesFileTypeId, priorityType, purchaseInvoiceType, customerAgreementTerms }
            });

            dispatch(setCustomerSendInfoListR(customerSendInfoList))

            let customerNamesData = customerNamesRaw.map((customer) => {
                return { value: customer.id, key: customer.fullName, purchaseInvoiceType: customer.purchaseInvoiceType }
            })

            dispatch(setCustomerNamesForOrdersR(customerNamesData))

        },
        onError: () => {
            // console.log('customerNamesErrrorrrr..!!')
        }

    })
}


const useGetAllCustomersNameList = (getAgainCustomerList) => {
    const dispatch = useDispatch();
    return useQuery(['useGetAllCustomersNameList'], getAllCustomersNameForOrder, {
        refetchOnWindowFocus: false,
        enabled: !!getAgainCustomerList,
        cacheTime: Infinity
        ,
        onSuccess: (data) => {
            let rawData = data?.data?.data;
            let customerSendInfoList = rawData.map(({ customerSendInfo, id, elasticNumbers, receivesFileTypeId, priorityType }) => {
                return { id, customerSendInfo, elasticNumbers, receivesFileTypeId, priorityType }
            });

            dispatch(setCustomerSendInfoListR(customerSendInfoList))

            let customerNamesList = rawData?.map((customer) => {
                let { fullName, id } = customer;
                return { fullName, id }

            })
            // console.log(customerNamesList)
            return customerNamesList
        }


    })
}





const useAddOrder = (handleAddOrderSuccess, handleAddOrderFailed) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    // debugger
    return useMutation(addOrder, {
        onSuccess: (data) => {
            queryClient.invalidateQueries(['getAllOrders'], { exact: true });
            let { data: addData } = data;
            let { data: fileData } = addData;
            dispatch(setAddOrderSuccessDataR(addData))
            handleAddOrderSuccess();
        }
        , onError: (err) => {
            handleAddOrderFailed();
            let messages = getMessages(err);
            let asyncReult = {
                messages: messages,
                type: 'error'
            }
            dispatch(setAsyncOprationsMessagesR(asyncReult));
        }
    })
}

const useUploadOrderFile = (uploadOrderFileSuccess, uploadOrderFileError) => {
    const dispatch = useDispatch();
    return useMutation(uploadOrderFile, {
        // retryDelay:10000,
        // retry:false,

        onSuccess: (data) => {
            uploadOrderFileSuccess()


        }
        ,
        onError: (err) => {
            uploadOrderFileError()
        }
    }

    )
}

const useDeleteOrder = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteOrder, {
        onSuccess: () => {
            queryClient.invalidateQueries('getAllOrders')
        }
        ,
        onError: () => {
            // console.log('orderDeleteError...!!!!')
        }
    })
}



const useGetAllDamageCause = () => {
    return useQuery(['getAllDamageCause'], getAllDamageCause, {
        refetchOnWindowFocus: false,
        onError: () => {
            // console.log('get all damage error')
        }
        ,
        onSuccess: (data) => {
            // console.log('getAllDamageSuccess')
        }
        ,
        select: (data) => {

            let damageCauseRaw = data?.data.data;
            let damageCauseData = damageCauseRaw.map((damage) => {
                return { value: damage.id, key: damage.damageCause }
            })
            return damageCauseData
        }
    })
}

const useGetAllLpi = () => {
    return useQuery(['getAllApi'], getAllApi, {
        refetchOnWindowFocus: false,
        cacheTime: Infinity,

        onSuccess: (data) => {
            // console.log(' getAllApi Suucess..!!!',data)
        }
        ,
        onError: () => {
            // console.log('getAllApi Errorooror..!!!')
        },
        select: (data) => {

            const lpiData = data?.data.data.map((lpi) => {
                return { key: lpi.lpi, value: lpi.id }
            })

            return lpiData
        }


    })
}

const useGetAllOrganizationUnit = () => {
    return useQuery(['getAllOrganizationUnit'], getOrganizationDepartman, {
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        enabled: true,
        // refetchOnMount:false,
        onSuccess: (data) => {

        }
        ,
        onError: () => {
            // console.log('getOrganizationUnit Errorooror..!!!')
        }
        ,
        select: (data) => {
            let rawData = data?.data?.data;
            let readyData = rawData.map((depart) => {
                return { key: depart.unitName, value: depart.id }
            })
            return readyData
            // console.log(readyData)
        }
    })
}



const useGetPrintedInstanceType = () => {

    return useQuery(['getPrintedInstanceType'], getPrintedInstanceType, {
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        enabled: true,
        refetchOnMount: false,
        onSuccess: () => {

        },
        onError: () => {
            // console.log('PrintedInstanceTypeerrrrrrrrr')
        },
        select: (data) => {

            const printedInstanceType = data?.data.data.map((instance) => {
                return { key: instance.instanceTypeTitle, value: instance.id }
            })
            return printedInstanceType

        }
    })





}

const useGetPrintedInstanceKeepStatus = () => {
    return useQuery(['getPrintedInstanceKeepStatus'], getPrintedInstanceKeepStatus, {
        cacheTime: Infinity,
        refetchOnWindowFocus: false,

        onError: () => {
            // console.log('GetPrintedInstanceKeepStatuseerrrrrrrrr')
        },
        select: (data) => {

            const PrintedInstanceKeepStatus = data?.data.data.map((instance) => {
                return { key: instance.instanceKeepedStatusTitle, value: instance.id }
            })

            return PrintedInstanceKeepStatus

        }
    })

}

const useGetKlischeThikness = (id) => {
    return useQuery(['getKlischeThikness', id], getKlischeThikness, {
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        enabled: !!id,
        onError: () => {
            // console.log('thikErrorrr')
        }
        ,
        onSuccess: () => {

        }
        ,
        select: (data) => {
            let rawData = data?.data.data;
            let klischeThiknessData = rawData.map((klisThik) => {
                return { key: klisThik.klischeThickness, value: klisThik.klischeThicknessId, klischeThicknessType: klisThik.klischeThicknessType }
            })
            return klischeThiknessData
        }

    })
}


const useGetKlischeTypes = (id) => {
    return useQuery(['getKlischeTypes', id], getKlischeTypes, {
        enabled: !!id,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onError: (err) => {
            // console.log(err)
        }
        ,
        onSuccess: (data) => {
            // console.log(data)
        }
        ,

        select: (data) => {
            let rawData = data?.data.data;
            let transformed = rawData.map((item) => {

                let { klischeTypeName,
                    klischeThickness,
                    klischeThicknessId,
                    klischeTypeId,
                    klischeTypeCategory,
                    klischeThicknessType,
                    klischeTypeAndThicknessId,
                    klischeCategoryId
                } = item;

                let klischeDetails = { klischeThicknessType: klischeThicknessType, klischeTypeCategory: klischeTypeCategory, klischeTypeAndThicknessId, klischeTypeId, klischeCategoryId }
                return {
                    key: klischeTypeName + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0 " + klischeThickness,
                    klischeTypeId: klischeTypeId,
                    klischeDetails: klischeDetails,
                    klischeThicknessId: klischeThicknessId,
                    klischeTypeAndThicknessId: klischeTypeAndThicknessId
                }

            })
            // console.log(transformed,'transformed')
            return transformed
        }
    })
}

const useGetCustomerMachineInfo = () => {
    const dispatch = useDispatch();
    return useMutation(getCustomerMachineInfo, {
        onSuccess: (data) => {
            //  console.log(data)
            let customerMachineInfo = data?.data.data
            dispatch(setCustomerMachineInfoR(customerMachineInfo))

        }
    })
}

const useGetCustomerMachineInfo2 = (customerId) => {
    return useQuery(['getCustomerMachineInfo', customerId], getCustomerMachineInfo, {
        enabled: !!customerId,
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        onSuccess: (data) => {
            // console.log(data)
        },
        onError: (err) => {
            // console.log(err)
        },
        select: (data) => {
            let rawData = data?.data?.data;
            //   console.log(rawData)
            return rawData
        }
    })
}

const useGetCustomerMachineInfoDetails = (id) => {
    const dispatch = useDispatch()
    return useQuery(['getCustomerMachineInfoDetails', id], getCustomerMachineInfoDetails, {
        refetchOnWindowFocus: false,
        enabled: !!id,
        onError: () => {
            // console.log('getCustomerMachineInfoDetails Errrororoororo.!!')
        }
        ,
        onSuccess: (data) => {
            let rawData = data?.data.data
            dispatch(setCustomerMachineDetailsR(rawData))

        }
    })

}



const useGetDesignerOfCustomer = (id) => {
    const dispatch = useDispatch();
    return useQuery(['getDesignerOfCustomer', id], getDesignerOfCustomer, {
        enabled: !!id,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            //     console.log(data)
            //     let rawData=data?.data.data;
            //     let readyData=rawData.map((designer)=>{
            //    return {key:designer.fullName,value:designer.designerId,bgColor:designer.styleColor}

            //     })


            // dispatch(setCustomerDesignerR(readyData))
        },
        select: (data) => {
            // console.log(data)
            let rawData = data?.data.data;
            let readyData = rawData.map((designer) => {
                return { key: designer.fullName, value: designer.designerId, bgColor: designer.styleColor }

            })
            return readyData

        }
        ,

        onError: () => {
            // console.log('customerDesignerErrorrrrr..!!!')
        }
    })
}



const useGetOrganizationDepartman = () => {
    return useQuery(['GetOrganizationDepartman'], getOrganizationDepartman, {
        enabled: true,
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        onError: () => {
            // console.log('getunitErrroororor')
        },
        select: (data) => {
            let rawData = data?.data.data;
            let unitsDataReady = rawData.map((unit) => {
                return { key: unit.unitName, value: unit.id }
            })
            return unitsDataReady
        }
    })
}

const useGetMachineLpi = (machineId) => {

    return useQuery(['getMachineLpi', machineId], getMachineLpi, {
        enabled: !!machineId,
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        onError: () => {
            // console.log('machineLpiEroooorrrr..!!!!')
        }
        ,
        onSuccess: (data) => {
            // console.log(data)
        },


        select: (data) => {
            let rawData = data?.data.data
            let machineLpiReadyData = rawData.map((lpi) => {
                return { id: lpi.lpiId, lpi: lpi.lpi, color: lpi.lpiColor }
            })

            return machineLpiReadyData

        }
    })
}

const useGetlastOrderNumber = () => {
    const dispatch = useDispatch();

    return useQuery(['getLastOrderNumber'], getLastOrderNumber, {
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        enabled: false,
        select: (data) => {
            let rawData = data?.data.data;
            return rawData;

        }
    })
}


const useGetOrderDetails = () => {
    const dispatch = useDispatch()
    return useMutation(getOrderDetails, {
        onSuccess: (data) => {

            // console.log(data)
            let orderData = data?.data.data
            // dispatch(setOrderViewDataR(orderData))
            dispatch(setOrderSelectedR(orderData))

        },
        onError: () => {
            // console.log('getdetailsError..!!!!')
        }
    })
}

const useGetOrderView = (id) => {
    const dispatch = useDispatch()
    return useMutation(getOrderView, {
        onSuccess: (data) => {
            // console.log(data)
            dispatch(setOrderViewDataR(data?.data.data))
        }
        ,
        onError: (err) => {
            // console.log(err)
        }
    })

}



const useDeleteOrderImage = (onSuccessDon, failedSend) => {
    return useMutation(deleteOrderImage, {
        onSuccess: (data) => {
            onSuccessDon()
        }
        ,
        onError: (err) => {
            failedSend()
        }
    })
}



const useDeleteOrderDepartmanDescription = (deleteDepartmanDescriptionSuccess, deleteDepartmanDescriptionFailed) => {
    return useMutation(deleteOrderDepartmanDescription, {
        onSuccess: (data) => {
            deleteDepartmanDescriptionSuccess()
        }
        ,
        onError: (err) => {
            deleteDepartmanDescriptionFailed()
        }
    })
}

const useGetOrderByOrderNumber = () => {
    const dispatch = useDispatch()
    return useMutation(getOrderByOrderNumber, {

        onSuccess: (data) => {
            let rawData = data?.data.data;
            dispatch(setPreviousOrderR(rawData))
            // console.log(rawData)
        },
        onError: (err) => {
            // console.log(err)
        }
    })
}

const useGetSingleOrder = (id) => {
    return useQuery(['getSingleOrder', id], getSingleOrder, {
        enabled: !!id,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            // console.log(data)
        }
        ,
        onError: (err) => {
            // console.log(err)
        },
        select: (data) => {
            let rawData = data?.data?.data;
            // console.log(rawData)
            return rawData;
        }
    })
}

// const useUpdateOrder=(handleUpdateSuccess,handleAddOrderFailed)=>{
//     const queryClient = useQueryClient();
//     const dispatch = useDispatch();
//     // debugger
//     return useMutation(updateOrder, 
//         {
//         onSuccess: (data) => {
//             queryClient.invalidateQueries(['getAllOrders'],{exact:true});
//             handleUpdateSuccess();
//         }
//         , onError: (err) => {
//             console.log(err)
//             handleAddOrderFailed();
//         }
//     })

// }


// const useAddOrder = (handleAddOrderSuccess,handleAddOrderFailed) => {
//     const queryClient = useQueryClient();
//     const dispatch = useDispatch();
//     // debugger
//     return useMutation(addOrder, {
//         onSuccess: (data) => {
//             queryClient.invalidateQueries(['getAllOrders'],{exact:true});
//             let {data:addData}=data;
//             let {data:fileData}=addData;
//             console.log(fileData);
//             dispatch(setAddOrderSuccessDataR(addData))
//             console.log('onSuccesRun');
//             handleAddOrderSuccess();
//         }
//         , onError: (err) => {
//             handleAddOrderFailed();
//             let messages = getMessages(err);
//             let asyncReult = {
//                 messages: messages,
//                 type: 'error'
//             }
//             dispatch(setAsyncOprationsMessagesR(asyncReult));
//         }
//     })
// }











// addOrderSuccessData
const useUpdateOrder = (handleUpdateSuccess, handleAddOrderFailed) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (orderData) => {
            return updateOrder(orderData)
        },
        onSuccess: (data) => {
            // console.log(data)
            queryClient.invalidateQueries(['getAllOrders']);

            dispatch(setAddOrderSuccessDataR(data))
            handleUpdateSuccess();
        },
        onError: (err) => {

            let { response: { data: { resourceKeyResult: { resourceKeyList } } } } = err;
            let response = resourceKeyList[0]?.resourceKeys[0];
            let error = {
                type: 'errors',
                messages: response

            }

            // console.log(error)

            dispatch(setAsyncOprationsMessagesR({ type: 'errors', messages: response }))



            handleAddOrderFailed();
            //  return err
        }

    })
}











const useGetAllOrderDeliverInfo = (orderId) => {
    return useQuery(['getAllOrderDeliverInfo', orderId], getAllOrderDeliverInfo, {
        enabled: !!orderId,
        refetchOnWindowFocus: false,
        cacheTime: Infinity,

        onSuccess: (data) => {
            // console.log(data)
        }
        ,
        onError: (err) => {
            //  console.log(err)
        },
        select: (data) => {
            let rawData = data?.data.data;
            return rawData
            // console.log(rawData)

        }


    })
}

const useGetAllDesignerGroup = () => {
    return useQuery(['getAllDesignerGroup'], getAllDesignerGroup, {
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        enabled: true
        ,
        onSuccess: (data) => {
            // console.log(data)
        }
        ,
        onError: (err) => {
            //  console.log(err)
        },
        select: (data) => {
            let rawData = data?.data.data;

            let readyData = rawData.map((item) => {
                let { title, id } = item;
                return { key: title, value: id }
            })

            return readyData


        }

    })
}

// getAllDesignerGroup

// deleteOrderAnilux
const useDeleteOrderAnilux = (deleteOrderAniluxSuccess, deleteOrderAniluxFailed) => {
    return useMutation({

        mutationFn: (id) => deleteOrderAnilux(id),
        onSuccess: (data) => {
            // console.log(data)
            deleteOrderAniluxSuccess()
        },
        onError: (err) => {
            //  console.log(err)
            deleteOrderAniluxFailed()
        }

    })
}
// deleteOrderAniluxes
const useDeleteAllOrderAniluxes = () => {
    return useMutation({
        mutationFn: (orderId) => deleteOrderAniluxes(orderId),
        onSuccess: (data) => {
            // console.log(data)
        }
        ,
        onError: (err) => {
            // console.log(err)
        }
    })
}



const useUpdateOrderColors = (onSuccess, onError) => {
    const dispatch = useDispatch();
    return useMutation({
        mutationFn: (colorsUpdated) => updateOrderColors(colorsUpdated),
        onSuccess: (data) => {
            onSuccess()
        },
        onError: (err) => {
            let { response: { data: { resourceKeyResult: { resourceKeyList } } } } = err;
            let response = resourceKeyList[0]?.resourceKeys[0];
            let error = {
                type: 'errors',
                messages: response

            }

            // console.log(error)

            dispatch(setAsyncOprationsMessagesR({ type: 'errors', messages: response }))

        }
    });
};

// export default useUpdateOrderColors;

// GetOrderReturnsByOrderId
const useGetOrderAniloxes = (orderId) => {
    return useQuery(['getOrderAniloxes', orderId], getOrderAniloxes, {

        enabled: !!orderId,
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        onSuccess: (data) => {
            //    console.log(orderId)
        }
        ,
        onError: (err) => {
            //    console.log(err)
        },
        select: (data) => {
            let rawData = data?.data?.data;
            //    console.log(rawData)
            return rawData

        }
    })
}

const useDeleteColorSelection = (colorDeleteSucces, colorDeleteError) => {
    return useMutation({
        mutationFn: (colorId) => deleteColorSelection(colorId),
        onSuccess: (data) => {
            colorDeleteSucces()
        }
        ,
        onError: (err) => {
            colorDeleteError()
        }
    })
}

const useGetRefreshedOrderColors = (orderId) => {
    return useQuery(['GetRefreshedOrderColorss', orderId], getRefreshedOrderColors, {
        enabled: false,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,

        onError: (err) => {
            console.log(err)
        }
        ,
        select: (data) => {
            let rawData = data?.data?.data;
            let transFormed = rawData?.map((item) => {
                return { type: 'saved', ...item }
            })
            return transFormed

        }

    })
}

const useDeleteOrderPrintedInstance = (deleteInstanceSuccess, deleteInstanceFailed) => {
    return useMutation({
        mutationFn: (instanceId) => deleteOrderPrintedInstance(instanceId),
        onSuccess: (instanceId) => {
            deleteInstanceSuccess()
        }
        ,
        onError: (err) => {
            deleteInstanceFailed()
        }
    })
}

const useGetOrderDamageByOrderId = (orderId, fetchStatus) => {
    return useQuery(['getOrderDamageByOrderId', orderId], getOrderDamageByOrderId, {
        enabled: !!orderId && fetchStatus,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onError: (err) => {
            console.log(err)
        }
        ,
        select: (data) => {
            let rawData = data?.data?.data;
            return rawData
        }

    })
}

const useAssignReturnsToOrder = () => {
    return useMutation({
        mutationFn: (body) => AssignReturnsToOrder(body),
        onSuccess: (body) => {
            // ()
        }
        ,
        onError: (err) => {
            deleteInstanceFailed()
        }
    })
}

// GetOrderReturnsByOrderId
const useGetOrderReturnsByOrderId = (orderId) => {
    return useQuery(['GetOrderReturnsByOrderId', orderId], GetOrderReturnsByOrderId, {

        enabled: !!orderId,
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        onSuccess: (data) => {
            //    console.log(orderId)
        }
        ,
        onError: (err) => {
            //    console.log(err)
        },
        select: (data) => {
            let rawData = data?.data;
            return rawData

        }
    })
}


export {
    useGetAllOrders,
    useAddOrder,
    useUploadOrderFile,
    useDeleteOrder,
    useGetAllCustomersName,
    useGetAllDamageCause,
    useGetAllLpi,
    useGetAllOrganizationUnit,
    useGetPrintedInstanceType,
    useGetPrintedInstanceKeepStatus,
    useGetKlischeThikness,
    useGetKlischeTypes,
    useGetCustomerMachineInfo,
    useGetCustomerMachineInfoDetails,
    useGetDesignerOfCustomer,
    useGetOrganizationDepartman,
    useGetMachineLpi,
    useGetlastOrderNumber,
    useGetOrderDetails,
    useGetOrderView,
    useDeleteOrderImage,
    useDeleteOrderDepartmanDescription,
    useGetOrderByOrderNumber,
    useGetSingleOrder,
    useUpdateOrder,
    useGetCustomerMachineInfo2,
    useGetAllOrderDeliverInfo,
    useDeleteOrderAnilux,
    useDeleteAllOrderAniluxes,
    useUpdateOrderColors,
    useGetOrderAniloxes,
    useDeleteColorSelection,
    useGetRefreshedOrderColors,
    useDeleteOrderPrintedInstance,
    useGetAllCustomersNameList,
    useGetAllDesignerGroup,
    useGetOrderDamageByOrderId,
    useAssignReturnsToOrder,
    useGetOrderReturnsByOrderId,
    useNewGetAllOrders,



}


